/**
 * Checks whether an element is an editable text field
 * @param element Element to check
 */
export const isDOMElementEditable = (element: Element): boolean => (
  element.nodeName === 'DIV' && (element as HTMLDivElement).contentEditable === 'true' ||
  element.nodeName === 'INPUT' && ((element as HTMLInputElement).type === 'text' || (element as HTMLInputElement).type === 'search' ||
  (element as HTMLInputElement).type === 'password') || element.nodeName === 'TEXTAREA'
);
